<template lang="pug">
  vue-tel-input.fi-phone-input(
    :value              = 'value'
    v-bind              = '$attrs'
    autocomplete        = 'off'
    :input-options      = '{ showDialCode: true }'
    :default-country    = 'country'
    :inputClasses       = 'inputClass'
    mode                = 'international'
    @input              = 'setValue'
  )
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import { mapState } from 'vuex'

export default {
  name: "fi-phone-input",

  components: { VueTelInput },

  inheritAttrs: false,

  props: {
    country: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    inputClass: {
      type: [String, Object, Array],
      default: null
    }
  },

  methods: {
    setValue(value, { number, regionCode }) {
      this.$emit('update:country', regionCode)
      this.$emit("input", number.e164);
    }
  }
};
</script>

<style lang="scss" scoped>
.fi-phone-input {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid #bfbfbf;
  border-radius: 0;
  &:focus-within {
    box-shadow: unset;
    border-color: unset;
  }
  & .vti__input {
    color: inherit;
  }
}
</style>
